import { Match, Show, Switch, createEffect, createMemo, createSignal, splitProps } from "solid-js";
import { createFormControl } from "solid-forms";
import type { MainProps } from "./_model";
import type { FormControlData, FormControlValue } from "../SHARED/_model";

export default function <V extends FormControlValue, D extends FormControlData>(props: MainProps<V, D>) {
  const [local, others] = splitProps(props, ["control", "onChange", "update"]);
  const _control = Array.isArray(local.control) ? createFormControl<V, D>(...local.control) : local.control;
  const control_is_array = Array.isArray(local.control);

  const [$show_password, set_show_password] = createSignal(false);
  const $with_icon = createMemo(() => {
    let result = false;
    if (others.type === "password") {
      result = true;
    }
    return result;
  });
  const $type = createMemo(() => {
    if (others.type === "password") {
      return $show_password() ? "text" : "password";
    }
    return others.type;
  });

  createEffect(() => {
    if (control_is_array && local.update) {
      _control.setValue(local.control[0]);
    }
  });

  createEffect(() => {
    if (others.disabled != undefined) {
      _control.markDisabled(others.disabled);
    }
    if (others.required != undefined) {
      _control.markRequired(others.required);
    }
  });

  return (
    <div
      class={`relative flex flex-row w-full h-full justify-between items-center overflow-hidden ${others.class ?? ""}`}
      classList={{
        invalid: !!_control.errors,
        touched: _control.isTouched,
        disabled: _control.isDisabled,
        required: _control.isRequired,
        ...others.classList,
      }}
    >
      <input
        {...others}
        class="input"
        type={$type()}
        value={others.type !== "file" ? (_control.value as any) : ""}
        oninput={(e) => {
          const { type } = others; //e.currentTarget || {};
          let v = e.currentTarget.value as V;
          if (type === "radio") {
            v = e.currentTarget.id as V;
          } else if (type === "checkbox") {
            // v = e.currentTarget.id as V;
            // v = (!e.target.checked ? "false" : "true") as V;
            v = e.target.checked as unknown as V;
            // console.log("form ype is :: ", type, v);
          } else if (type === "file") {
            if (e.target.files && e.target.files?.[0]) {
              v = e.target.files?.[0] as any as V;
              // _control.setValue(content);
            }
          }

          // console.log("value form is :: ", v);
          _control.setValue(v);
          if (_control.isValid) {
            if (local.onChange) {
              local.onChange(v);
            }
          }
        }}
        onblur={() => _control.markTouched(true)}
        onfocus={() => _control.markTouched(true)}
        onfocusin={() => _control.markTouched(true)}
        onfocusout={() => _control.markTouched(false)}
        disabled={_control.isDisabled}
        required={_control.isRequired}
      />
      <Show when={$with_icon()}>
        <div class="flex flex-row w-auto h-fit px-2 justify-center items-start cursor-pointer <sm:(px-1)">
          <Switch>
            <Match when={others.type === "password"}>
              {$show_password() ? (
                <i
                  class="icon-ri:eye-fill w-24px h-24px <sm:(w-23px h-23px)"
                  onclick={() => set_show_password(false)}
                />
              ) : (
                <i
                  class="icon-ri:eye-close-fill w-24px h-24px <sm:(w-23px h-23px)"
                  onclick={() => set_show_password(true)}
                />
              )}
            </Match>
          </Switch>
        </div>
      </Show>
    </div>
  );
}
